import axios from 'src/api/Api';
import {
    GET_INVENTORY_DATA_SUCCESS,
    GET_INVENTORY_DATA_FAILURE
} from '../actions';

import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getInventoryDetails(action) {
    const productType = action.payload ? action.payload.productType : '';
    const accountNumber = action.payload ? action.payload.accountNumber : '';
    const currentPage = action.payload ? action.payload.currentPage : '';
    const orderType = action.payload ? action.payload.orderType : '';
    const resourceType = action.payload ? action.payload.resourceType : '';
    const sortCode = action.payload ? action.payload.sortCode : '';
    const sortOrder = action.payload ? action.payload.sortOrder : '';
    const filterParam = action.payload ? action.payload.filterParam : '';
    const searchQuery = action.payload ? action.payload.searchQuery : '';
    const pageSize = action.payload ? action.payload.pageSize : '';
    try {
        const result = yield axios({
            method: 'get',
           url:`occ/v2/${localStorage.getItem('baseSiteId')}/consignment/inventory?productType=${encodeURIComponent(productType)}&accountNumber=${encodeURIComponent(accountNumber)}&currentPage=${encodeURIComponent(currentPage)}&orderType=${encodeURIComponent(orderType)}&resourceType=${encodeURIComponent(resourceType)}&sortCode=${encodeURIComponent(sortCode)}&sortOrder=${encodeURIComponent(sortOrder)}&filterParam=${encodeURIComponent(filterParam)}&searchQuery=${encodeURIComponent(searchQuery)}&pageSize=${encodeURIComponent(pageSize)}`,
        }).then((response) => response.data);
        yield put({
            type: GET_INVENTORY_DATA_SUCCESS,
            payload: result,
        });
    } catch (e) {
        const url = `occ/v2/${localStorage.getItem('baseSiteId')}/consignment/inventory?productType=${encodeURIComponent(productType)}&accountNumber=${encodeURIComponent(accountNumber)}&currentPage=${encodeURIComponent(currentPage)}&orderType=${encodeURIComponent(orderType)}&resourceType=${encodeURIComponent(resourceType)}&sortCode=${encodeURIComponent(sortCode)}&sortOrder=${encodeURIComponent(sortOrder)}&filterParam=${encodeURIComponent(filterParam)}&searchQuery=${encodeURIComponent(searchQuery)}&pageSize=${encodeURIComponent(pageSize)}`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_INVENTORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
